import styled from 'styled-components';

const FooterGroup = styled.div `
  padding: 0 32px 32px;
`;
const StyledFooter = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export { FooterGroup, StyledFooter };
